import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ChipNavigationMui } from '@mi-front/ui';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { StationAuditPage } from '../../components/StationAuditPage';
import { useAuditClientConfigQuery } from '../../hooks/useAuditClientConfigQuery';
import { AuditNoMatchesReportView } from './reports/audios-without-matches/NoMatchesReport';
import { BcrMatchesReportView } from './reports/bcr-matches/BcrMatchesReport';
import { LtxMatchesReportView } from './reports/ltx-matches/LtxMatchesReport';
import { AuditEqualMd5ReportView } from './reports/equal-md5/EqualMd5Report';
import { MissingAudiosReportView } from './reports/missing-audios/MissingAudiosReport';

export function StationReportsPage() {
  const station = useActiveStation();
  const { $t } = useIntl();
  const { data: auditConfig } = useAuditClientConfigQuery();

  const system = auditConfig?.runAsLogConfirmation?.system;

  const chips = useMemo(() => {
    const base = [
      {
        value: 'equal-md5',
        label: $t({
          id: 'audit.reportsScreen.equalMd5.title',
          defaultMessage: 'Archivos con mismo contenido',
        }),
        content: <AuditEqualMd5ReportView station={station} />,
      },
      {
        value: 'no-matches',
        label: $t({
          id: 'audit.reportsScreen.noMatches.title',
          defaultMessage: 'Archivos sin matches',
        }),
        content: <AuditNoMatchesReportView station={station} />,
      },
      {
        value: 'missing-media',
        label: $t({
          id: 'audit.reportsScreen.missingAudios.title',
          defaultMessage: 'Archivos faltantes',
        }),
        content: <MissingAudiosReportView station={station} />,
      },
    ];

    if (system === 'bcr') {
      base.push({
        value: 'bcr-matches',
        label: $t({
          id: 'audit.reportsScreen.bcrMatches.title',
          defaultMessage: 'BCR Matches',
        }),
        content: <BcrMatchesReportView station={station} />,
      });
    } else if (system === 'ltx') {
      base.push({
        value: 'ltx-matches',
        label: $t({
          id: 'audit.reportsScreen.ltxMatches.title',
          defaultMessage: 'LTX Matches',
        }),
        content: <LtxMatchesReportView station={station} />,
      });
    }

    return base;
  }, [station, system, $t]);

  return (
    <StationAuditPage
      title={$t({
        id: 'audit.reportsScreen.title',
        defaultMessage: 'Reportes',
      })}
    >
      <ChipNavigationMui
        pathBase={`/audit/s/${station.slug}/reports`}
        pathParamName="reportType"
        defaultActiveChip="equal-md5"
        chips={chips}
        Wrapper={PageToolbar}
      />
    </StationAuditPage>
  );
}
